import { apiErrorToToast } from "@/lib/utils";
import { createResourceLink } from "@/requests/libraries/create-resource-link.request";
import { ApiErrorResponse } from "@/types/apis";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { AxiosError } from "axios";

export const useCreateResourceLinkMutation = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: createResourceLink,
    onSuccess: (_, variables) => {
      queryClient.invalidateQueries({
        queryKey: [
          "companies",
          variables.companyId,
          "resource-libraries",
          variables.resourceLibraryId,
          "resources",
        ],
      });
    },
    onError: (error: AxiosError<ApiErrorResponse>) => {
      apiErrorToToast(error);
    },
  });
};
